import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e4e3834"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Vissza")
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 1,
  class: "bottom-absolute"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin-bottom" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Keress rá arra, akit bejelölnél ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "ion-text-center" }, [
  /*#__PURE__*/_createTextVNode("Írhatod a keresztnevét, "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" vezetéknevét és a felhasználónevét is.")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createBlock(_component_ion_modal, {
    "is-open": _ctx.friendSearchModal.open,
    "swipe-to-close": true,
    "show-backdrop": true,
    "presenting-element": 
            _ctx.friendSearchModal.presentingElement?.$el ||
            _ctx.$root.$refs.mainRouterOutlet.$el
        ,
    onDidDismiss: _ctx.dismiss
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_searchbar, {
                animated: "",
                debounce: "100",
                modelValue: _ctx.query,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
                placeholder: "Keresés"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _ctx.dismiss,
                    class: "l"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { class: "relative" }, {
        default: _withCtx(() => [
          (_ctx.query != '')
            ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (res) => {
                    return (_openBlock(), _createBlock(_component_ion_item, {
                      key: res.id,
                      onClick: ($event: any) => (_ctx.openProfile(res))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_avatar, { slot: "start" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: 
                                './assets/image/avatars/' +
                                res.username +
                                '.jpg'
                            
                            }, null, 8, _hoisted_2)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createElementVNode("h3", null, _toDisplayString(res.firstName + " " + res.lastName), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.query == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _hoisted_5,
                _createVNode(_component_ion_img, {
                  src: './assets/image/start_searching_friends.png',
                  class: "end-image"
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["is-open", "presenting-element", "onDidDismiss"]))
}